import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

import { TrialToaster } from '../components/trial-toaster/trial-toaster';

@Injectable()
export class TrialToasterService {
    private subject = new Subject<TrialToaster>();
    private keepAfterRouteChange = false;

    constructor(private router: Router) {
        router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterRouteChange) {
                    this.keepAfterRouteChange = false;
                } else {
                    this.clear();
                }
            }
        });
    }

    public getToaster(): Observable<any> {
        return this.subject.asObservable();
    }

    public toaster(title: string, keepAfterRouteChange = false): void {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next(<TrialToaster> { title });
    }

    public clear(): void {
        this.subject.next();
    }
}
